import * as React from 'react'
import { Masonry, MasonryItem } from 'react-masonry-responsive'
import { Card, Image, Header, Divider } from 'semantic-ui-react'

interface ServiceCardProps {
  image: string
  header: string
  content: string
}

const servicesData: ServiceCardProps[] = [
  {
    image:
      '//res.cloudinary.com/danrx4fes/image/upload/c_fill,w_307,h_167/SERVICOS/ARQ_CEL6',
    header: 'Projeto de Arquitetura',
    content:
      'Definir através do programa de necessidades a metodologia de trabalho a ser aplicada nas etapas do projeto, com todas as informações essenciais para a execução da obra.',
  },
  {
    image:
      '//res.cloudinary.com/danrx4fes/image/upload/c_fill,w_307,h_167/SERVICOS/ARQ_INT_1',
    header: 'Arquitetura Corporativa',
    content:
      'Criar soluções eficientes e funcionais, atendendo critérios de ergonomia. Distribuir o layout dos ambientes priorizando o fluxo de processos e integração entre as equipes.',
  },
  {
    image:
      '//res.cloudinary.com/danrx4fes/image/upload/c_fill,w_307,h_167/SERVICOS/Gerenc_Obra_MTR2',
    header: 'Gerenciamento e Acompanhamento de Obra',
    content:
      'Acompanhar e cumprir o planejamento da obra, através do controle de prazos, recursos e custos, para atender aos padrões de qualidade e excelência do projeto.',
  },
  {
    image:
      '//res.cloudinary.com/danrx4fes/image/upload/c_fill,w_307,h_167/SERVICOS/COORD_PROJ',
    header: 'Gerenciamento e Compatibilização de Projetos',
    content:
      'Integrar todas as disciplinas para identificar as interferências entre os diversos projetos complementares de instalações e promover a melhor solução para a execução da obra.',
  },
]

const ServiceCard = ({ image, header, content }: ServiceCardProps) => {
  return (
    <Card fluid>
      <Image src={image} />
      <Card.Content>
        <Card.Header>{header}</Card.Header>
        <Card.Description>{content}</Card.Description>
      </Card.Content>
    </Card>
  )
}

const Services = () => {
  const items: MasonryItem[] = servicesData.map((x) => ({
    key: x.header,
    node: <ServiceCard {...x} />,
  }))

  return (
    <div>
      <Header size='large'>O que fazemos</Header>
      <Divider hidden />
      <Card.Group>
        <Masonry items={items} minColumnWidth={290} />
      </Card.Group>
    </div>
  )
}

export default Services
